export const STATUS = {
  dalam_persiapan: { label: "Dalam Persiapan", cls: "text-amber-500 bg-amber-500/10 border-amber-500/20" },
  siap_jual: { label: "Siap Jual", cls: "text-emerald-500 bg-emerald-500/10 border-emerald-500/20" },
  booking: { label: "Booking (Belum Lunas)", cls: "text-sky-400 bg-sky-500/10 border-sky-500/20" },
  terjual: { label: "Terjual", cls: "text-blue-500 bg-blue-500/10 border-blue-500/20" },
};

export const PAYMENT_TYPES = {
  dp: "Down Payment",
  cash: "Cash / Lunas",
  leasing: "Leasing",
};

export const PURCHASE_PAYMENT_TYPES = {
  dp: "Down Payment",
  cash: "Cash / Lunas",
};

export const SALE_PAYMENT_TYPES = {
  cash: "Cash",
  leasing: "Leasing",
};

export const COST_CATEGORIES = {
  body_repair: "Body Repair",
  mesin: "Mesin",
  dokumen: "Dokumen",
  aksesoris: "Aksesoris",
  lain_lain: "Lain-lain",
};

export const OP_CATEGORIES = [
  "Gaji Karyawan",
  "Sewa Tempat",
  "Listrik & Air",
  "Marketing",
  "Transportasi",
  "Administrasi",
  "Lain-lain",
];

export const CASH_IN_CATEGORIES = {
  penjualan: "Penjualan",
  setoran_modal: "Setoran Modal",
  pelunasan_piutang: "Pelunasan Piutang",
  refund_pembelian: "Refund Pembelian",
  transfer_masuk: "Transfer Antar Cabang",
  lain_lain: "Lain-lain",
};

export const CASH_OUT_CATEGORIES = {
  pembelian_mobil: "Pembelian Mobil",
  biaya_mobil: "Biaya Mobil",
  operasional: "Biaya Operasional",
  komisi: "Komisi",
  setoran_konsinyasi: "Setoran Konsinyasi",
  refund_penjualan: "Refund Penjualan",
  transfer_keluar: "Transfer Antar Cabang",
  lain_lain: "Lain-lain",
};

export const ROLES = {
  admin: "Owner",
  admin_cabang: "Admin Cabang",
  admin_ho: "Admin HO",
  staff: "Staff",
};

export const carLabel = (c) =>
  [c?.merk, c?.model, c?.color, c?.year, c?.plate].filter(Boolean).join(" ");

export const PERMISSIONS = {
  kelola_mobil: "Kelola Mobil (tambah/edit)",
  pindah_lokasi: "Pindah Lokasi Stok antar Cabang",
  foto_mobil: "Edit Foto Mobil",
  kelola_pembelian: "Kelola Pembelian (catat/edit)",
  input_biaya_mobil: "Input Biaya Mobil",
  input_biaya_operasional: "Input Biaya Operasional",
  input_penjualan: "Input Penjualan & Terima Dana",
  aksi_penjualan: "Aksi Penjualan (edit/tandai lunas/set harga)",
  refund_penjualan: "Refund Penjualan",
  kas_manual: "Catat Kas Manual",
  lihat_laporan: "Lihat Dashboard & Laporan Akuntansi",
  lihat_hpp: "Lihat Harga Beli & Modal",
};

export const DEFAULT_PERMS = {
  staff: Object.keys(PERMISSIONS),
  admin_cabang: ["pindah_lokasi", "foto_mobil", "input_biaya_mobil", "input_penjualan", "refund_penjualan", "kas_manual"],
  admin_ho: ["pindah_lokasi", "foto_mobil", "input_biaya_mobil", "kas_manual", "input_penjualan", "aksi_penjualan"],
};

export const can = (user, perm) =>
  user?.role === "admin" ||
  (user?.role === "admin_cabang" && perm === "input_biaya_operasional" ? false :
    (user?.permissions || DEFAULT_PERMS[user?.role] || []).includes(perm));
